import { sentryFactory } from '@grantstreet/sentry'

// Use the same DSNs as govhub-vue to make sure errors are routed to the right Sentry project
const dsns = {
  // govhub-ui-prod
  prod: 'https://10c054b10b974c81b73423a0d835e640@o168195.ingest.sentry.io/1432778',
  // govhub-ui-nonprod
  nonprod: 'https://0b277d98b53c4c4ab0748b2ede995898@o168195.ingest.sentry.io/5827657',
}

// Export the Sentry integration using the selected DSN
export const {
  sentryException,
  vueErrorHandler,
  chainClient,
} = sentryFactory({
  dsns,
  clientOptions: {
    sampleRate: 0.5, // Match govhub-vue's sample rate
  },
})
